// extracted by mini-css-extract-plugin
export default {"result":"PasswordResult_result__jaBZ1","result__title":"PasswordResult_result__title__0GSG6","result__box":"PasswordResult_result__box__e68+c"};